import React, { useEffect, useState } from 'react';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import axios from 'axios';
import {token, domain} from './../components/Security';
import { CreateSearchBarWithPlaceHolder } from '../components/CommonObjects';
import {CreateTableForEmployeeSelect} from '../components/ManageTable';
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from '@mui/icons-material/Search';
import loadingSpinner from './../assets/loading.gif';

//#region Table
const getNestedValue = (tableName, obj, path, actions) => {
  const value = path.split('.').reduce((acc, part) => {
    if (!acc) return undefined;

    // Handle array access like 'employeeinformations[0]'
    const match = part.match(/^(\w+)\[(\d+)\]$/);
    if (match) {
      const [, arrayKey, index] = match;
      return acc[arrayKey]?.[parseInt(index, 10)];
    }

    return acc[part];
  }, obj);

  // --- Handle specific formatting/conditions ---
  if (path === 'isactive' || path === 'isActive') {
    return value ? 'Active' : 'Inactive';
  }

  if (path === 'errors') {
    if(value){
      const formattedErrors = value.replace(/\\n/g, '\n');

      return (
        <pre className="text-red-500 whitespace-pre-wrap max-h-[100px]">
          {formattedErrors}
        </pre>
      );
    }
  }

  if (path === 'IsActive') {
    return value === 1 ? 'True' : 'False';
  }

  if (path === 'hasCompleted') {
    return value ? 'Yes' : 'No';
  }

  if (path === 'employeeinformations.status') {
    return value ? 'Approved' : 'Unapproved';
  }

  if (path === 'timefrom' || path === 'timeto') {
    if (!value) return '-';
    const date = new Date(value);
    return date.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  }

  if (['DateFrom', 'DateTo', 'date', 'datefrom', 'dateto', 'dateofbirth', 'DateOfBirth'].includes(path)) {
    if (!value) return '-';
    const date = new Date(value);
    if (isNaN(date.getTime())) return '-';
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  }

  if (tableName === 'Company' && path === 'logo') {
    if(!value){
      return <></>
    }
    
    const foundAction = actions.find(i => i.name === 'View');
    return (
      <button
        className="text-white p-[1px] rounded-md bg-sky-600 hover:bg-sky-700"
        title="View Logo"
        onClick={() => foundAction.function(obj)}
      >
        {foundAction.icon}
      </button>
    );
  }
  if ((tableName === 'OnBoarding' || tableName === 'OutBoarding') && path === 'file') {
    if(!value){
      return <>No uploaded file</>
    }
    
    const foundAction = actions.find(i => i.name === 'Download');
    return (
      <button
        className="text-white p-[1px] rounded-md bg-sky-600 hover:bg-sky-700 border-none cursor-pointer"
        title="Download"
        onClick={() => foundAction.function(obj)}
      >
        {foundAction.icon}
      </button>
    );
  }

  if (tableName === 'EmployeeSchedule' && path === 'employeeshiftschedules') {
    const foundAction = actions.find(i => i.name === 'View');
    return (
      <button
        className="text-white p-[1px] rounded-md bg-sky-600 hover:bg-sky-700"
        title="View Schedule"
        onClick={() => foundAction.function(obj)}
      >
        {foundAction.icon}
      </button>
    );
  }

  if (tableName === 'Company' && path === 'logo') {
    if(!value){
      return <></>
    }
    
    const foundAction = actions.find(i => i.name === 'View');
    return (
      <button
        className="text-white p-[1px] rounded-md bg-sky-600 hover:bg-sky-700"
        title="View Logo"
        onClick={() => foundAction.function(obj)}
      >
        {foundAction.icon}
      </button>
    );
  }

  if (tableName === 'Calendar' && path === 'image') {
    if(!value){
      return <></>
    }

    const foundAction = actions.find(i => i.name === 'View');
    return (
      <button
        className="text-white p-[1px] rounded-md bg-sky-600 hover:bg-sky-700"
        title="View Logo"
        onClick={() => foundAction.function(obj)}
      >
        {foundAction.icon}
      </button>
    );
  }

  if (tableName === 'HolidayType') {
    if (path === 'payrateifnotworked' || path === 'payrateifworked') {
      return `${value}%`;
    }
  }

  if (tableName === 'Holiday' && path === 'holidaylocations') {
    if (obj.isalllocation) {
      return <span>All locations</span>;
    }
    return (
      <span>
        {Array.isArray(value) && value.length > 0
          ? value.map(loc => loc.locations.description).join(', ')
          : '-'}
      </span>
    );
  }

  const formatDate = (value) =>{
    const date = new Date(value);
    if (isNaN(date.getTime())) return '';
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  }

  if (( tableName === 'Overtime' 
    || tableName === 'DTRCorrection' 
    || tableName === 'Leave' 
    || tableName === 'ChangeOfSchedule')
    && (path === 'daterequested' || path === 'datefrom' || path === 'dateto')) {

    if (!value) return '-';

    const date = new Date(value);
    if (isNaN(date.getTime())) return '-';
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  }

  if (( tableName === 'Overtime' 
    || tableName === 'DTRCorrection' 
    || tableName === 'Leave' 
    || tableName === 'ChangeOfSchedule')
    && (path === 'content')) {

    if(!value){
      return <></>
    }
    
    const foundAction = actions.find(i => i.name === 'Image');
    return (
      <button
        className="text-white p-[1px] rounded-md bg-sky-600 hover:bg-sky-700"
        title="View Image"
        onClick={() => foundAction.function(obj)}
      >
        {foundAction.icon}
      </button>
    );
  }

  if (
    (tableName === 'Overtime' ||
      tableName === 'DTRCorrection' ||
      tableName === 'Leave' ||
      tableName === 'ChangeOfSchedule') &&
    path === 'approvals'
  ) {
    if (!value) return <>-</>;

    const getStatusClass = (status) => {
      switch (status) {
        case 'Approved':
          return 'text-green-500';
        case 'Disapproved':
          return 'text-red-500';
        case 'Cancelled':
          return 'text-gray-400'; // faded gray
        default:
          return ''; // Sent or undefined — normal text
      }
    };

    return (
      <>
        {value.primaryapproverstatus !== undefined && (
          <div className="flex flex-col mb-2">
            Primary Approver Status:{' '}
            <span className={getStatusClass(value.primaryapproverstatus)}>
              {value.primaryapproverstatus ?? 'Sent'}
            </span>
            { (value.primaryapproverstatus === "Approved" 
            || value.primaryapproverstatus === "Disapproved" 
            || value.primaryapproverstatus === "Cancelled") &&
              <>
                <span>
                  {`${value.primaryapprover?.fullname}`}
                </span>
                <span>
                  {`${formatDate(value.primaryapproverupdatedate)}`}
                </span>
              </>
            }
          </div>
        )}
        {value.secondaryapproverstatus !== undefined && (
          <div className="flex flex-col mb-2">
            Secondary Approver Status:{' '}
            <span className={getStatusClass(value.secondaryapproverstatus)}>
              {value.secondaryapproverstatus ?? 'Sent'}
            </span>
            { (value.secondaryapproverstatus === "Approved" 
            || value.secondaryapproverstatus === "Disapproved" 
            || value.secondaryapproverstatus === "Cancelled") &&
              <>
                <span>
                  {`${value.secondaryapprover?.fullname}`}
                </span>
                <span>
                  {`${formatDate(value.secondaryapproverupdatedate)}`}
                </span>
              </>
            }
          </div>
        )}
        {value.tertiaryapproverstatus !== undefined && (
          <div className="flex flex-col">
            Tertiary Approver Status:{' '}
            <span className={getStatusClass(value.tertiaryapproverstatus)}>
              {value.tertiaryapproverstatus ?? 'Sent'}
            </span>
            { (value.tertiaryapproverstatus === "Approved" 
            || value.tertiaryapproverstatus === "Disapproved" 
            || value.tertiaryapproverstatus === "Cancelled") &&
              <>
                <span>
                  {`${value.tertiaryapprover?.fullname}`}
                </span>
                <span>
                  {`${formatDate(value.tertiaryapproverupdatedate)}`}
                </span>
              </>
            }
          </div>
        )}
      </>
    );
  }

  if (tableName === 'Overtime' && (path === 'hasovertimeallowance' || path === 'isabovetwohoursovertime')) {
    return value ? 'True' : 'False';
  }

  if (tableName === 'Overtime' && (path === 'referencenumber')) {
    if (!value) return '-';
    return `OT-${value}`;
  }

  if (tableName === 'DTRCorrection' && (path === 'timein' || path === 'timeout' || path === 'timerendered')) {
    if(!value){
      return <>-</>
    }

    const date = new Date(value);
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yyyy = date.getFullYear();
    const _date = `${mm}/${dd}/${yyyy}`;

    const _time = date.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });

    return `${_date} ${_time}`
  }

  if (tableName === 'DTRCorrection' && (path === 'referencenumber')) {
    if (!value) return '-';
    return `DC-${value}`;
  }

  if (tableName === 'Leave' && (path === 'referencenumber')) {
    if (!value) return '-';
    return `LV-${value}`;
  }

  if (tableName === 'Leave' && path === 'ishalfday') {
    return value ? 'True' : 'False';
  }

  if (tableName === 'ChangeOfSchedule' && (path === 'referencenumber')) {
    if (!value) return '-';
    return `CS-${value}`;
  }

  if (tableName === 'ApproverHierarchy' && path === 'primaryapprovers') {
    if (!value) return <>-</>;

    return (
      <>
        {value.primaryapprover1?.fullname && <div className="mb-2">{value.primaryapprover1.fullname}</div>}
        {value.primaryapprover2?.fullname && <div className="mb-2">{value.primaryapprover2.fullname}</div>}
        {value.primaryapprover3?.fullname && <div className="mb-2">{value.primaryapprover3.fullname}</div>}
        {value.primaryapprover4?.fullname && <div>{value.primaryapprover4.fullname}</div>}
      </>
    );
  }

  if (tableName === 'ApproverHierarchy' && path === 'secondaryapprovers') {
    if (!value) return <>-</>;

    return (
      <>
        {value.secondaryapprover1?.fullname && <div className="mb-2">{value.secondaryapprover1.fullname}</div>}
        {value.secondaryapprover2?.fullname && <div className="mb-2">{value.secondaryapprover2.fullname}</div>}
        {value.secondaryapprover3?.fullname && <div className="mb-2">{value.secondaryapprover3.fullname}</div>}
        {value.secondaryapprover4?.fullname && <div>{value.secondaryapprover4.fullname}</div>}
      </>
    );
  }

  if (tableName === 'ApproverHierarchy' && path === 'tertiaryapprovers') {
    if (!value) return <>-</>;

    return (
      <>
        {value.tertiaryapprover1?.fullname && <div className="mb-2">{value.tertiaryapprover1.fullname}</div>}
        {value.tertiaryapprover2?.fullname && <div className="mb-2">{value.tertiaryapprover2.fullname}</div>}
        {value.tertiaryapprover3?.fullname && <div className="mb-2">{value.tertiaryapprover3.fullname}</div>}
        {value.tertiaryapprover4?.fullname && <div>{value.tertiaryapprover4.fullname}</div>}
      </>
    );
  }

  return value;
};
export const CreateTable = ({ 
  tableName, 
  headers, 
  accessors, 
  data, 
  emptyMessage = 'No data available', 
  actions, 
  currentPage, 
  setCurrentPage, 
  itemsPerPage, 
  totalItems 
}) => {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });

  const rowsPerPage = itemsPerPage;

  const totalPages = Math.ceil(totalItems / rowsPerPage);

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const allowSort = false;
  const allowFirstAndLastPage = true;

  const handleSort = (accessor) => {
    if(allowSort){
      setSortConfig(prevConfig => {
        if (prevConfig.key === accessor) {
          // Cycle through: null -> ascending -> descending -> null ...
          if (prevConfig.direction === null) {
            return { key: accessor, direction: 'asc' };
          } else if (prevConfig.direction === 'asc') {
            return { key: accessor, direction: 'desc' };
          } else {
            return { key: null, direction: null };
          }
        } else {
          return { key: accessor, direction: 'asc' };
        }
      });
    }
  };

  const getSortSymbol = (accessor) => {
    if (sortConfig.key !== accessor) return '';
    if (sortConfig.direction === 'asc') return '▲';
    if (sortConfig.direction === 'desc') return '▼';
    return '';
  };

  return (
    <>
      <div className="w-full overflow-x-auto">
        <table className="min-w-full table-auto text-left text-sm border border-gray-300" style={{border: "1px solid #dfdfdf"}}>
          <thead className="bg-[#668fca] text-white font-semibold uppercase tracking-wider">
            <tr>
              {headers.map((header, index) => (
                <th
                  key={index}
                  onClick={() => handleSort(accessors[index])}
                  className={`px-4 py-2 ${allowSort ? "cursor-pointer select-none" : ""}`}
                >
                  <div className="flex items-center gap-1 min-w-[100px]">
                    {header}
                    <span className="text-xs">{getSortSymbol(accessors[index])}</span>
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data?.length > 0 ? (
              data.map((row, rowIndex) => (
                <tr key={rowIndex} className="border-t hover:bg-gray-100 odd:bg-white even:bg-gray-50">
                  {accessors.map((accessor, colIndex) => (
                    <td key={colIndex} 
                    className={`px-4 py-2 max-w-[150px] overflow-hidden hover:overflow-auto whitespace-nowrap
                    `}
                    >
                      {accessor === 'actions' ? (
                        <div className="flex space-x-2">
                          {actions.filter(i => i.visible).map((action, actionIndex) => (
                            <button
                              key={actionIndex}
                              onClick={() => action.function(row)}
                              className={`text-white ${action.color} p-[1px] rounded-md ${action.className} border-none cursor-pointer flex- items-center`}
                              title={action.tooltip}
                            >
                              {action.icon}
                            </button>
                          ))}
                        </div>
                      ) : (
                        (() => {
                          const value = getNestedValue(tableName, row, accessor, actions) ?? '-';
                          const isTrue = value === 'True' || value === "Yes" || value === "Subscribed" || value === "Active" || value === "Approved";
                          const isFalse = value === 'False' || value === "No" || value === "Unsubscribed" || value === "Inactive" || value === "Unapproved";
                          return (
                            <span className={`${isTrue && accessor !== "description" ? 'text-green-500 font-semibold' : ''} ${isFalse && accessor !== "description" ? 'text-red-500 font-semibold' : ''}
                                        ${accessor === "activeUsers" ? "text-green-500 font-semibold" : ""}
                                        ${accessor === "inActiveUsers" ? "text-red-500 font-semibold" : ""}
                            `}>
                              {value}
                            </span>
                          );
                        })()
                      )}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={headers.length} className="px-4 py-4 text-center text-gray-500">
                  {emptyMessage}
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {/* Pagination Controls */}
        {totalPages > 1 && (
          <div className="flex items-center justify-center space-x-4 mt-4">
            { allowFirstAndLastPage &&
              <button
                onClick={() => setCurrentPage(1)}
                disabled={currentPage === 1}
                className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
              >
                <FirstPageIcon fontSize='small'/>
              </button>
            }

            <button
              onClick={handlePrevPage}
              disabled={currentPage === 1}
              className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
            >
              <NavigateBeforeIcon fontSize='small'/>
            </button>

            <span className="text-gray-700">
              Page {currentPage} of {totalPages}
            </span>

            <button
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
              className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
            >
              <NavigateNextIcon fontSize='small'/>
            </button>

            { allowFirstAndLastPage &&
              <button
                onClick={() => setCurrentPage(totalPages)}
                disabled={currentPage === totalPages}
                className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
              >
                <LastPageIcon fontSize='small'/>
              </button>
            }
          </div>
        )}
      </div>
    </>
  );
};
export const CreateTableCustom = ({ 
  tableName, 
  headers, 
  accessors, 
  data, 
  emptyMessage = 'No data available', 
  actions, 
  currentPage, 
  setCurrentPage, 
  itemsPerPage, 
  totalItems 
}) => {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });

  const rowsPerPage = itemsPerPage;

  const totalPages = Math.ceil(totalItems / rowsPerPage);

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const allowSort = false;
  const allowFirstAndLastPage = true;

  const handleSort = (accessor) => {
    if(allowSort){
      setSortConfig(prevConfig => {
        if (prevConfig.key === accessor) {
          // Cycle through: null -> ascending -> descending -> null ...
          if (prevConfig.direction === null) {
            return { key: accessor, direction: 'asc' };
          } else if (prevConfig.direction === 'asc') {
            return { key: accessor, direction: 'desc' };
          } else {
            return { key: null, direction: null };
          }
        } else {
          return { key: accessor, direction: 'asc' };
        }
      });
    }
  };

  const getSortSymbol = (accessor) => {
    if (sortConfig.key !== accessor) return '';
    if (sortConfig.direction === 'asc') return '▲';
    if (sortConfig.direction === 'desc') return '▼';
    return '';
  };

  return (
    <>
      <div className="w-full overflow-x-auto">
        <table className="min-w-full table-auto text-left text-sm border border-gray-300" style={{border: "1px solid #dfdfdf"}}>
          <thead className="bg-[#668fca] text-white font-semibold uppercase tracking-wider">
            <tr>
              {headers.map((header, index) => (
                <th
                  key={index}
                  onClick={() => handleSort(accessors[index])}
                  className={`px-4 py-2 ${allowSort ? "cursor-pointer select-none" : ""}`}
                >
                  <div className="flex items-center gap-1 min-w-[100px]">
                    {header}
                    <span className="text-xs">{getSortSymbol(accessors[index])}</span>
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data?.length > 0 ? (
              data.map((row, rowIndex) => (
                <tr key={rowIndex} className="border-t hover:bg-gray-100 odd:bg-white even:bg-gray-50">
                  {accessors.map((accessor, colIndex) => (
                    <td key={colIndex} 
                    className={`px-4 py-2 max-w-[150px] overflow-hidden hover:overflow-auto whitespace-nowrap
                    `}
                    >
                      {accessor === 'actions' ? (
                        <div className="flex space-x-2">
                          {actions.filter(i => i.visible).map((action, actionIndex) => (
                            <button
                              key={actionIndex}
                              onClick={() => action.function(row)}
                              className={`text-white ${action.color} p-[1px] rounded-md ${action.className} border-none cursor-pointer flex- items-center`}
                              title={action.tooltip}
                            >
                              {action.icon}
                            </button>
                          ))}
                        </div>
                      ) : (
                        (() => {
                          const value = getNestedValue(tableName, row, accessor, actions) ?? '-';
                          const isTrue = value === 'True' || value === "Yes" || value === "Subscribed" || value === "Active" || value === "Approved";
                          const isFalse = value === 'False' || value === "No" || value === "Unsubscribed" || value === "Inactive" || value === "Unapproved";
                          return (
                            <span className={`${isTrue && accessor !== "description" ? 'text-green-500 font-semibold' : ''} ${isFalse && accessor !== "description" ? 'text-red-500 font-semibold' : ''}
                                        ${accessor === "activeUsers" ? "text-green-500 font-semibold" : ""}
                                        ${accessor === "inActiveUsers" ? "text-red-500 font-semibold" : ""}
                            `}>
                              {value}
                            </span>
                          );
                        })()
                      )}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={headers.length} className="px-4 py-4 text-center text-gray-500">
                  {emptyMessage}
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {/* Pagination Controls */}
        {totalPages > 1 && (
          <div className="flex items-center justify-center space-x-4 mt-4">
            { allowFirstAndLastPage &&
              <button
                onClick={() => setCurrentPage(1)}
                disabled={currentPage === 1}
                className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
              >
                <FirstPageIcon fontSize='small'/>
              </button>
            }

            <button
              onClick={handlePrevPage}
              disabled={currentPage === 1}
              className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
            >
              <NavigateBeforeIcon fontSize='small'/>
            </button>

            <span className="text-gray-700">
              Page {currentPage} of {totalPages}
            </span>

            <button
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
              className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
            >
              <NavigateNextIcon fontSize='small'/>
            </button>

            { allowFirstAndLastPage &&
              <button
                onClick={() => setCurrentPage(totalPages)}
                disabled={currentPage === totalPages}
                className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
              >
                <LastPageIcon fontSize='small'/>
              </button>
            }
          </div>
        )}
      </div>
    </>
  );
};
export const CreateTableSelectMode = ({
  tableName,
  headers,
  accessors,
  data,
  emptyMessage = 'No data available',
  actions,
  currentPage,
  setCurrentPage,
  itemsPerPage,
  totalItems,
  selectedRow,
  setSelectedRow,
}) => {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });

  const rowsPerPage = itemsPerPage;
  const totalPages = Math.ceil(totalItems / rowsPerPage);
  const allowSort = false;
  const allowFirstAndLastPage = true;

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handleSort = (accessor) => {
    if (allowSort) {
      setSortConfig(prev => {
        if (prev.key === accessor) {
          if (prev.direction === null) return { key: accessor, direction: 'asc' };
          if (prev.direction === 'asc') return { key: accessor, direction: 'desc' };
          return { key: null, direction: null };
        } else {
          return { key: accessor, direction: 'asc' };
        }
      });
    }
  };

  const getSortSymbol = (accessor) => {
    if (sortConfig.key !== accessor) return '';
    return sortConfig.direction === 'asc' ? '▲' : '▼';
  };

  return (
    <div className="w-full overflow-x-auto">
      <table className="min-w-full table-auto text-left text-sm border border-gray-300" style={{border: "1px solid #dfdfdf"}}>
        <thead className="bg-[#668fca] text-white font-semibold uppercase tracking-wider">
          <tr>
            {headers.map((header, index) => (
              <th
                key={index}
                onClick={() => handleSort(accessors[index])}
                className={`px-4 py-2 ${allowSort ? "cursor-pointer select-none" : ""}`}
              >
                <div className="flex items-center gap-1 min-w-[100px]">
                  {header}
                  <span className="text-xs">{getSortSymbol(accessors[index])}</span>
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.length > 0 ? (
            data.map((row, rowIndex) => (
              <tr
                key={rowIndex}
                onClick={() => setSelectedRow(row)}
                className={`border-t cursor-pointer ${
                  selectedRow?.id === row.id ? "bg-blue-400 text-white hover:bg-blue-500" : rowIndex % 2 === 0 ? "bg-white hover:bg-gray-100" : "bg-gray-50 hover:bg-gray-100"
                }`}
              >
                {accessors.map((accessor, colIndex) => (
                  <td key={colIndex} 
                    className={`px-4 py-2 max-w-[150px] overflow-hidden hover:overflow-auto whitespace-nowrap
                    `}
                  >
                    {accessor === 'actions' ? (
                      <div className="flex space-x-2">
                        {actions.filter(i => i.visible).map((action, actionIndex) => (
                          <button
                            key={actionIndex}
                            onClick={(e) => {
                              e.stopPropagation(); // prevent row selection on button click
                              action.function(row);
                            }}
                              className={`text-white ${action.color} p-[1px] rounded-md ${action.className} border-none cursor-pointer flex- items-center`}
                            title={action.tooltip}
                          >
                            {action.icon}
                          </button>
                        ))}
                      </div>
                    ) : (
                      (() => {
                        const value = getNestedValue(tableName, row, accessor, actions) ?? '-';
                        const isTrue = ['True', 'Yes', 'Subscribed', 'Active'].includes(value);
                        const isFalse = ['False', 'No', 'Unsubscribed', 'Inactive'].includes(value);
                        return (
                          <span className={`${
                            isTrue && accessor !== "description" ? 'text-green-500 font-semibold' : ''
                          } ${
                            isFalse && accessor !== "description" ? 'text-red-500 font-semibold' : ''
                          }`}>
                            {value}
                          </span>
                        );
                      })()
                    )}
                  </td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={headers.length} className="px-4 py-4 text-center text-gray-500">
                {emptyMessage}
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {totalPages > 1 && (
        <div className="flex items-center justify-center space-x-4 mt-4">
          {allowFirstAndLastPage && (
            <button
              onClick={() => setCurrentPage(1)}
              disabled={currentPage === 1}
              className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
            >
              <FirstPageIcon fontSize="small" />
            </button>
          )}

          <button
            onClick={handlePrevPage}
            disabled={currentPage === 1}
            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
          >
            <NavigateBeforeIcon fontSize="small" />
          </button>

          <span className="text-gray-700">
            Page {currentPage} of {totalPages}
          </span>

          <button
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
          >
            <NavigateNextIcon fontSize="small" />
          </button>

          {allowFirstAndLastPage && (
            <button
              onClick={() => setCurrentPage(totalPages)}
              disabled={currentPage === totalPages}
              className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
            >
              <LastPageIcon fontSize="small" />
            </button>
          )}
        </div>
      )}
    </div>
  );
};
export const CreateTableMultipleSelectMode = ({
  tableName,
  headers,
  accessors,
  data,
  emptyMessage = 'No data available',
  actions,
  currentPage,
  setCurrentPage,
  itemsPerPage,
  totalItems,
  // --- Changed for multiple selection ---
  selectedRows,      // Now an array of selected row objects
  setSelectedRows,   // Function to update the array
  // ------------------------------------
}) => {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });

  const rowsPerPage = itemsPerPage;
  const totalPages = Math.ceil(totalItems / rowsPerPage);
  const allowSort = false;
  const allowFirstAndLastPage = true;

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handleSort = (accessor) => {
    if (allowSort) {
      setSortConfig(prev => {
        if (prev.key === accessor) {
          if (prev.direction === null) return { key: accessor, direction: 'asc' };
          if (prev.direction === 'asc') return { key: accessor, direction: 'desc' };
          return { key: null, direction: null };
        } else {
          return { key: accessor, direction: 'asc' };
        }
      });
    }
  };

  const getSortSymbol = (accessor) => {
    if (sortConfig.key !== accessor) return '';
    return sortConfig.direction === 'asc' ? '▲' : '▼';
  };

  // --- New: Handle row selection ---
  const handleRowSelection = (row) => {
    // Check if the row is already selected
    const isSelected = selectedRows.some(selected => selected.id === row.id);

    if (isSelected) {
      // If selected, remove it from the array
      setSelectedRows(prevSelected => prevSelected.filter(selected => selected.id !== row.id));
    } else {
      // If not selected, add it to the array
      setSelectedRows(prevSelected => [...prevSelected, row]);
    }
  };

  // --- New: Handle "Select All" ---
  const handleSelectAll = (event) => {
    if (event.target.checked) {
      // If checkbox is checked, add all current page data to selectedRows
      // Ensure no duplicates if some were already selected
      const newSelected = [...selectedRows];
      data.forEach(row => {
        if (!newSelected.some(selected => selected.id === row.id)) {
          newSelected.push(row);
        }
      });
      setSelectedRows(newSelected);
    } else {
      // If checkbox is unchecked, remove all current page data from selectedRows
      setSelectedRows(prevSelected => prevSelected.filter(
        selected => !data.some(row => row.id === selected.id)
      ));
    }
  };

  // --- Helper to check if all rows on current page are selected ---
  const isAllRowsSelected = data?.length > 0 && data.every(row =>
    selectedRows.some(selected => selected.id === row.id)
  );

  return (
    <div className="w-full overflow-x-auto">
      <table className="min-w-full table-auto text-left text-sm border border-gray-300" style={{border: "1px solid #dfdfdf"}}>
        <thead className="bg-[#668fca] text-white font-semibold uppercase tracking-wider">
          <tr>
            {/* New: Checkbox for Select All */}
            <th className="px-2 py-2 w-10">
              <input
                type="checkbox"
                onChange={handleSelectAll}
                checked={isAllRowsSelected}
                className="form-checkbox h-4 w-4 text-blue-600 rounded"
              />
            </th>
            {headers.map((header, index) => (
              <th
                key={index}
                onClick={() => handleSort(accessors[index])}
                className={`px-4 py-2 ${allowSort ? "cursor-pointer select-none" : ""}`}
              >
                <div className="flex items-center gap-1 min-w-[100px]">
                  {header}
                  <span className="text-xs">{getSortSymbol(accessors[index])}</span>
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.length > 0 ? (
            data.map((row, rowIndex) => (
              <tr
                key={rowIndex}
                // No direct onClick for row selection here, it's handled by the checkbox
                className={`border-t cursor-pointer ${
                  selectedRows.some(selected => selected.id === row.id)
                    ? "bg-blue-400 text-white hover:bg-blue-500"
                    : rowIndex % 2 === 0
                      ? "bg-white hover:bg-gray-100"
                      : "bg-gray-50 hover:bg-gray-100"
                }`}
              >
                {/* New: Checkbox for individual row selection */}
                <td className="px-2 py-2">
                  <input
                    type="checkbox"
                    checked={selectedRows.some(selected => selected.id === row.id)}
                    onChange={() => handleRowSelection(row)}
                    onClick={(e) => e.stopPropagation()} // Prevent row click from affecting checkbox
                    className="form-checkbox h-4 w-4 text-blue-600 rounded"
                  />
                </td>
                {accessors.map((accessor, colIndex) => (
                  <td key={colIndex}
                    className={`px-4 py-2 max-w-[150px] overflow-hidden hover:overflow-auto whitespace-nowrap`}
                  >
                    {accessor === 'actions' ? (
                      <div className="flex space-x-2">
                        {actions.filter(i => i.visible).map((action, actionIndex) => (
                          <button
                            key={actionIndex}
                            onClick={(e) => {
                              e.stopPropagation(); // prevent row selection on button click
                              action.function(row);
                            }}
                            className={`text-white ${action.color} p-[1px] rounded-md ${action.className} border-none cursor-pointer flex- items-center`}
                            title={action.tooltip}
                          >
                            {action.icon}
                          </button>
                        ))}
                      </div>
                    ) : (
                      (() => {
                        const value = getNestedValue(tableName, row, accessor, actions) ?? '-';
                        const isTrue = ['True', 'Yes', 'Subscribed', 'Active', 'Approved'].includes(value);
                        const isFalse = ['False', 'No', 'Unsubscribed', 'Inactive', 'Unapproved'].includes(value);
                        return (
                          <span className={`${
                            isTrue && accessor !== "description" ? 'text-green-500 font-semibold' : ''
                          } ${
                            isFalse && accessor !== "description" ? 'text-red-500 font-semibold' : ''
                          }`}>
                            {value}
                          </span>
                        );
                      })()
                    )}
                  </td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={headers.length + 1} className="px-4 py-4 text-center text-gray-500"> {/* +1 for the new checkbox column */}
                {emptyMessage}
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {totalPages > 1 && (
        <div className="flex items-center justify-center space-x-4 mt-4">
          {allowFirstAndLastPage && (
            <button
              onClick={() => setCurrentPage(1)}
              disabled={currentPage === 1}
              className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
            >
              <FirstPageIcon fontSize="small" />
            </button>
          )}

          <button
            onClick={handlePrevPage}
            disabled={currentPage === 1}
            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
          >
            <NavigateBeforeIcon fontSize="small" />
          </button>

          <span className="text-gray-700">
            Page {currentPage} of {totalPages}
          </span>

          <button
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
          >
            <NavigateNextIcon fontSize="small" />
          </button>

          {allowFirstAndLastPage && (
            <button
              onClick={() => setCurrentPage(totalPages)}
              disabled={currentPage === totalPages}
              className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
            >
              <LastPageIcon fontSize="small" />
            </button>
          )}
        </div>
      )}
    </div>
  );
};
//#endregion













//#region Button
export const Button = ({ icon, name, className, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={`flex items-center px-4 py-2 text-white rounded-lg shadow gap-2 w-max ${className}`}
    >
      {icon}
      <span>{name}</span>
    </button>
  );
};
export const ButtonIcon = ({ icon, name, className, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={`flex items-center px-4 py-2 text-white rounded-lg shadow gap-2 w-max ${className}`}
    >
      {icon}
    </button>
  );
};
export const SmallButton = ({ icon, name, className, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={`flex items-center px-2 py-1 text-sm text-white rounded-md shadow gap-2 w-max ${className}`}
    >
      {icon}
      <span>{name}</span>
    </button>
  );
};
//#endregion













//#region Message Modal
export const SuccessMessage = ({ message, onClose }) => {
  if (!message) return null;

  return (
    <div className="fixed top-5 left-1/2 -translate-x-1/2 z-[9999]">
      <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative shadow-md flex items-start" role="alert">
        <div className="flex-grow">
          <strong className="font-bold">Success! </strong>
          <span className="block sm:inline">{message}</span>
        </div>
        <button
          onClick={onClose}
          className="ml-4 text-green-700 hover:text-green-900 font-bold"
        >
          ×
        </button>
      </div>
    </div>
  );
};
export const FailMessage = ({ message, onClose }) => {
  if (!message) return null;

  return (
    <div className="fixed top-5 left-1/2 -translate-x-1/2 z-[9999]">
      <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative shadow-md flex items-start" role="alert">
        <div className="flex-grow">
          <strong className="font-bold">Error! </strong>
          <span className="block sm:inline">{message}</span>
        </div>
        <button
          onClick={onClose}
          className="ml-4 text-red-700 hover:text-red-900 font-bold"
        >
          ×
        </button>
      </div>
    </div>
  );
};
export const ConfirmationModal = ({ visible, onClose, onSave, modalName, message }) => {
  if (!visible) return null;

  const handleSubmit = async () => {
    await onSave();
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center mx-auto" style={{zIndex: 9999}}>
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
        <h2 className="text-2xl font-semibold mb-4">{modalName}</h2>

        <div className="space-y-5 mt-10 max-h-[500px] overflow-y-auto short:max-h-[300px] medium:h-[400px]">
          <p className="text-gray-700 text-base">{message}</p>
        </div>

        <div className="flex justify-end space-x-2 mt-6">
          <button
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
            onClick={handleSubmit}
          >
            Yes
          </button>
          <button
            className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition"
            onClick={onClose}
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
};
//#endregion















//#region Selects
export function ApiCommonEmployeeSelectForm({isOpen, 
    onClose,
    data,
    setData}) 
{
  const [failMessage, setFailMessage] = useState("");

  var header = [
      "Id",
      "Name",
  ]
  var accessor = [
      "employeeId",
      "fullName"
  ]

  const handleClose = () => {
      onClose();
      fetchData();
      setFailMessage("")
  };
  const handleProceed = () => {
    if(!selectedEmployee){
      setFailMessage("Please select employee first.")
      return;
    }

    onClose();
    setData(selectedEmployee);
    fetchData();
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [filterData, setFilterData] = useState([]);
  const [filterDataIndex, setFilterDataIndex] = useState(0);
  const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

  const fetchData = async () => {
      const apiUrl =  domain + "/api/Employee/basic-info/all/active";

      try {
          setLoading(true);
          const response = await axios.get(apiUrl , {
          headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json' // You can include other headers if needed
          }})
              setEmployees(response.data); // Set the response data to the state
              setFilterData(response.data); // Set the response data to the state
      } catch (error) {
          console.error('Error fetching data:', error);
      } finally {
          setLoading(false); // Set loading state to false after data fetching is complete
      }
  }
  const handleFilter = (value) => {
      setCurrentPage(1);
      const lowercaseValue = value.toLowerCase();
      var res = [];

      switch (filterDataIndex) {
          case 0:
              res = filterData.filter((f) =>
              f.fullName.toLowerCase().includes(lowercaseValue)
              );
              break;
          case 1:
              res = filterData.filter((f) =>
              f.employeeId.toString().startsWith(lowercaseValue)
              );
              break;
          default:
              res = filterData.filter((f) =>
              f.fullName.toLowerCase().includes(lowercaseValue)
              );
              
              break;
      }

      setEmployees(res);
  };

  useEffect(() => {
      switch (filterDataIndex) {
          case 0:
              setSearchPlaceholder("Search by name")
              break;
          case 1:
              setSearchPlaceholder("Search by id")
              break;
          default:
              setSearchPlaceholder("Search by name")
              break;
      }
      fetchData();
  }, [filterDataIndex]);
  
  return (
      <>
          <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
              {isOpen && (
              <div className="modal">
                  <div className="popUp-header row">
                      <div className="popUp-title">
                          <h3 style={{ color: "#668fca" }}>Select Employee</h3>
                      </div>
                      <div className="popUp-close">
                          <CloseIcon onClick={()=>handleClose()} />
                      </div>
                  </div>
                  <div className="transaction-body">
                          <EmployeeFilter setFilterDataIndex={setFilterDataIndex}/>
                          <div className="transaction-body-top row">
                              {CreateSearchBarWithPlaceHolder("", 
                                                              "transaction-search row", 
                                                              "transaction-search-icon", 
                                                              "transaction-search-input", 
                                                              (e)=>handleFilter(e.target.value), 
                                                              searchPlaceholder,
                                                              SearchIcon)}
                          </div>
                      </div>
                  <div className="popUp-body">
                      <div className="select-employee-table">
                          <CreateTableForEmployeeSelect
                              dataList={employees}
                              dataHeader={header}
                              dataAccessor={accessor}
                              setSelectedEmployee={setSelectedEmployee}
                              currentPage={currentPage}
                              setCurrentPage={setCurrentPage}
                          />
                          {employees.length > 0 ? (
                                  <div></div>
                          )
                          :
                          (
                              <div>
                              {loading ? (
                                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                      <img src={loadingSpinner} alt="Loading..." />
                                  </div>
                              ) : (
                                      <div> {/*<p>No records to display</p>*/}</div>
                                  )
                              }
                              </div>
                          )}
                      </div>
                  </div>
                  <div className="buttons row" style={{justifyContent:"end", padding:"50px 20px 0 20px"}}>
                      <button id="add-family" 
                          className="save row"
                          onClick={handleProceed}>
                              PROCEED
                      </button>
                  </div>
              </div>
          )}
          </div>

          
          <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </>
  );
}
function EmployeeFilter({setFilterDataIndex}){
    const [selectedOption, setSelectedOption] = useState("All");

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "EmployeeId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="EmployeeId">Employee Id</option>
            </select>
        </div>
    );
};

export function OnBoardingPersonnelSelectForm({isOpen, 
    onClose,
    data,
    setData}) 
{
  const [failMessage, setFailMessage] = useState("");

  var header = [
      "Id",
      "Name",
  ]
  var accessor = [
      "employeeId",
      "fullName"
  ]

  const handleClose = () => {
      onClose();
      fetchData();
      setFailMessage("")
  };
  const handleProceed = () => {
    if(!selectedEmployee){
      setFailMessage("Please select employee first.")
      return;
    }

    onClose();
    setData(selectedEmployee);
    fetchData();
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [filterData, setFilterData] = useState([]);
  const [filterDataIndex, setFilterDataIndex] = useState(0);
  const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

  const fetchData = async () => {
      const apiUrl =  domain + "/api/OnBoardingPersonnel/active";

      try {
          setLoading(true);
          const response = await axios.get(apiUrl , {
          headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json' // You can include other headers if needed
          }})
              setEmployees(response.data); // Set the response data to the state
              setFilterData(response.data); // Set the response data to the state
      } catch (error) {
          console.error('Error fetching data:', error);
      } finally {
          setLoading(false); // Set loading state to false after data fetching is complete
      }
  }
  const handleFilter = (value) => {
      setCurrentPage(1);
      const lowercaseValue = value.toLowerCase();
      var res = [];

      switch (filterDataIndex) {
          case 0:
              res = filterData.filter((f) =>
              f.fullName.toLowerCase().includes(lowercaseValue)
              );
              break;
          case 1:
              res = filterData.filter((f) =>
              f.employeeId.toString().startsWith(lowercaseValue)
              );
              break;
          default:
              res = filterData.filter((f) =>
              f.fullName.toLowerCase().includes(lowercaseValue)
              );
              
              break;
      }

      setEmployees(res);
  };

  useEffect(() => {
      switch (filterDataIndex) {
          case 0:
              setSearchPlaceholder("Search by name")
              break;
          case 1:
              setSearchPlaceholder("Search by id")
              break;
          default:
              setSearchPlaceholder("Search by name")
              break;
      }
      fetchData();
  }, [filterDataIndex]);
  
  return (
      <>
          <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
              {isOpen && (
              <div className="modal">
                  <div className="popUp-header row">
                      <div className="popUp-title">
                          <h3 style={{ color: "#668fca" }}>Select Employee</h3>
                      </div>
                      <div className="popUp-close">
                          <CloseIcon onClick={()=>handleClose()} />
                      </div>
                  </div>
                  <div className="transaction-body">
                          <OnBoardingPersonnelFilter setFilterDataIndex={setFilterDataIndex}/>
                          <div className="transaction-body-top row">
                              {CreateSearchBarWithPlaceHolder("", 
                                                              "transaction-search row", 
                                                              "transaction-search-icon", 
                                                              "transaction-search-input", 
                                                              (e)=>handleFilter(e.target.value), 
                                                              searchPlaceholder,
                                                              SearchIcon)}
                          </div>
                      </div>
                  <div className="popUp-body">
                      <div className="select-employee-table">
                          <CreateTableForEmployeeSelect
                              dataList={employees}
                              dataHeader={header}
                              dataAccessor={accessor}
                              setSelectedEmployee={setSelectedEmployee}
                              currentPage={currentPage}
                              setCurrentPage={setCurrentPage}
                          />
                          {employees.length > 0 ? (
                                  <div></div>
                          )
                          :
                          (
                              <div>
                              {loading ? (
                                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                      <img src={loadingSpinner} alt="Loading..." />
                                  </div>
                              ) : (
                                      <div> {/*<p>No records to display</p>*/}</div>
                                  )
                              }
                              </div>
                          )}
                      </div>
                  </div>
                  <div className="buttons row" style={{justifyContent:"end", padding:"50px 20px 0 20px"}}>
                      <button id="add-family" 
                          className="save row"
                          onClick={handleProceed}>
                              PROCEED
                      </button>
                  </div>
              </div>
          )}
          </div>

          
          <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </>
  );
}
function OnBoardingPersonnelFilter({setFilterDataIndex}){
    const [selectedOption, setSelectedOption] = useState("All");

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "EmployeeId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="EmployeeId">Employee Id</option>
            </select>
        </div>
    );
};

export function OnBoardingRequirementsSelect({data, setData, isEditable, hasAll}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
      setIsSelected(true);
      const foundData = _data.find(i => i.id.toString() === event.target.value.toString());
      setData(foundData);
    };

    const [_data, _setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/OnBoardingRequirements/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            _setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        setIsSelected(data)
    }, [data]);

    return (
        <div>
            <select value={data ? data.id : ""} 
              className={`w-full rounded-md h-8 ${isSelected ? "text-gray-600" : "text-gray-400"}`}
              style={{border: "1px solid #d7d7d7"}}
              onChange={handleSelectChange}
              disabled={!isEditable}
            >
            {hasAll ? 
              <option value="">All</option>
              :
              <option value="" disabled hidden>Choose requirement</option>
            }
            {_data.map((dt, index) => ( 
                <option key={index} value={dt.id}>{
                    dt.description}
                </option>
            ))}
            </select>
        </div>
    );
};
export function OutBoardingRequirementsSelect({data, setData, isEditable, hasAll}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
      setIsSelected(true);
      const foundData = _data.find(i => i.id.toString() === event.target.value.toString());
      setData(foundData);
    };

    const [_data, _setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/OutBoardingRequirements/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            _setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        setIsSelected(data)
    }, [data]);

    return (
        <div>
            <select value={data ? data.id : ""} 
              className={`w-full rounded-md h-8 ${isSelected ? "text-gray-600" : "text-gray-400"}`}
              style={{border: "1px solid #d7d7d7"}}
              onChange={handleSelectChange}
              disabled={!isEditable}
            >
            {hasAll ? 
              <option value="">All</option>
              :
              <option value="" disabled hidden>Choose requirement</option>
            }
            {_data.map((dt, index) => ( 
                <option key={index} value={dt.id}>{
                    dt.description}
                </option>
            ))}
            </select>
        </div>
    );
};
//#endregion










//#region Searchbar
export const SearchBar = ({ handleFilter }) => {
  return (
    <div className="flex items-center my-2 rounded-md w-full max-w-md">
      <input
        type="text"
        onChange={(e) => handleFilter(e.target.value)}
        className="px-4 py-2 w-full border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder-gray-400 text-gray-600"
        style={{border: "1px solid #d7d7d7"}}
        placeholder="Search..."
      />
    </div>
  );
};
//#endregion